import React, { useState, useEffect } from "react";
import worldmap from "../../../../../../assets/images/common/worldmap.png";
import worldmapMobile from "../../../../../../assets/images/common/worldmapm.png";
import "./style.css";

export default function HeroSection() {
  const [backgroundImage, setBackgroundImage] = useState(worldmap);

  // Function to handle search when a popular item is clicked
  const handleSearch = (searchTerm) => {
    // Redirect to search results page with the specified format
    window.location.href = `/collection?category=global&search=${encodeURIComponent(
      searchTerm
    )}&`;
  };

  // Check screen size and set appropriate background image
  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth <= 1024) {
        setBackgroundImage(worldmapMobile);
      } else {
        setBackgroundImage(worldmap);
      }
    };

    // Check on initial load
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <>
      <div
        className="hero-container"
        style={{ 
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="overlay" />

        {/* Top Learn Section */}
        <div className="learn-section">
          <a
            href="https://youtu.be/fEgta2zjlx8?si=lBe-xddBMJgHPtky"
            className="learn-icon-circle"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="learn-icon">▶</span>
          </a>
          <a
            href="https://youtu.be/fEgta2zjlx8?si=lBe-xddBMJgHPtky"
            className="learn-text"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn about importerr.com
          </a>
        </div>

        {/* Main Content Wrapper */}
        <div className="hero-content-wrapper">
          <div className="hero-content">
            <h1 className="hero-title">
              Your E-Commerce Platform to Source Unique Products <br /> from China - No MOQ, Bulk Ready
            </h1>

            {/* Frequently searched items */}
            <div className="frequently-searched">
              <span className="frequently-label">Hot Categories:</span>
              <div className="search-items">
                <span
                  className="search-item"
                  onClick={() => handleSearch("Automatic Watches")}
                >
                  Automatic Watches
                </span>
                <span className="search-divider"></span>
                <span
                  className="search-item"
                  onClick={() => handleSearch("Pet Accessories")}
                >
                  Pet Accessories
                </span>
                <span className="search-divider"></span>
                <span
                  className="search-item"
                  onClick={() => handleSearch("Beauty Tools")}
                >
                  Beauty Tools
                </span>
                <span className="search-divider"></span>
              </div>
            </div>

            <div className="importerr-about-badges">
              <span className="importerr-badge">✅ Direct Suppliers</span>
              <span className="importerr-badge">✅ No Middlemen</span>
              <span className="importerr-badge">✅ No Hidden Costs</span>
              <span className="importerr-badge">✅ No High MOQ</span>
              <span className="importerr-badge">✅ GST-Ready</span>
            </div>

            {/* Description Removed */}
          </div>
        </div>

        {/* Why Choose Importerr Tile - Desktop - Now positioned separately */}
        <div className="why-choose-tile-desktop">
          <h3 className="why-choose-title">Why To Choose Importerr?</h3>
          <ul className="why-choose-list">
            <li>Test with a single unit, scale to larger quantities</li>
            <li>Upfront pricing with no hidden costs</li>
            <li>Smooth customs clearance and reliable doorstep delivery</li>
            <li>Automation for Amazon, Shopify sellers & D2C brands</li>
            <li>MOQ starts from 1 piece</li>
            <li>AI-assisted product sourcing</li>
          </ul>
        </div>
      </div>

      {/* Why Choose Importerr Tile - Mobile */}
      <div className="why-choose-tile-mobile">
        <h3 className="why-choose-title">Why To Choose Importerr?</h3>
        <ul className="why-choose-list">
          <li>Test with a single unit, scale to larger quantities</li>
          <li>Upfront pricing with no hidden costs</li>
          <li>Smooth customs clearance and reliable doorstep delivery</li>
          <li>Perfect for Amazon, Shopify & D2C brands</li>
          <li>MOQ starts from 1 piece</li>
          <li>AI-assisted product sourcing</li>
        </ul>
      </div>
    </>
  );
}
